import React from "react";

function TextCell({ cell: { value }, column: { className } }) {
  return <span className={className}>{value}</span>;
}

export default TextCell;
